import { render, staticRenderFns } from "./EmailSummary.vue?vue&type=template&id=20e90fa6&scoped=true&"
import script from "./EmailSummary.vue?vue&type=script&lang=js&"
export * from "./EmailSummary.vue?vue&type=script&lang=js&"
import style0 from "./EmailSummary.vue?vue&type=style&index=0&id=20e90fa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e90fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VListItem,VListItemAction,VListItemContent,VSheet,VSimpleTable})
